import { render, staticRenderFns } from "./StudentToken.vue?vue&type=template&id=27e5472b&style=height%3A%20100%25%3Bwidth%3A100%25%3B"
import script from "./StudentToken.vue?vue&type=script&lang=js"
export * from "./StudentToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports